<div class="payer-block"></div>
<form
  card
  [formGroup]="cardForm"
  [formatting]="true"
  class="custom_block"
  container=".payer-block"
  [placeholders]="FORM_PLACEHOLDERS"
>
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-12 form-group">
      <input
        type="text"
        name="number"
        card-number
        placeholder="Card number"
        class="form-control"
        formControlName="cardNumber"
      />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-12 form-group">
      <input
        type="text"
        name="full-name"
        card-name
        placeholder="Full name"
        class="form-control"
        formControlName="holderName"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <input type="text" name="expiry" card-expiry placeholder="MM/YY" class="form-control" formControlName="expDate" />
    </div>
    <div class="col-sm-6">
      <input type="text" name="cvc" card-cvc placeholder="CVC" class="form-control" formControlName="cvv" />
    </div>
  </div>
</form>
